"use client"

import { useState } from "react"
import { Handle, Position } from "reactflow"
import "./Node.css"
import "./BranchNode.css"
import { GitBranch, Minus, Square, Play, MoreHorizontal } from "lucide-react"

const BranchNode = ({ data, id }) => {
  const [expanded, setExpanded] = useState(false)
  const [conditions, setConditions] = useState(
    data.conditions || [{ type: "if", expression: "value.something === true" }],
  )
  const [activeTab, setActiveTab] = useState("Inputs")

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const addCondition = () => {
    setConditions([...conditions, { type: conditions.length === 0 ? "if" : "else if", expression: "" }])
  }

  const updateCondition = (index, expression) => {
    const newConditions = [...conditions]
    newConditions[index].expression = expression
    setConditions(newConditions)
  }

  const getConditionType = (index) => {
    if (index === 0) return "if"
    if (index === conditions.length - 1 && conditions.length > 1) return "else"
    return "else if"
  }

  return (
    <div className={`custom-node branch-node-v2 ${expanded ? "expanded" : ""}`}>
      <div className="branch-node-header">
        <div className="branch-node-title">
          <GitBranch size={16} className="branch-icon" />
          <span>{data.label || "branch2"}</span>
        </div>
        <div className="branch-node-controls">
          <button className="branch-node-button" onClick={toggleExpand}>
            <Minus size={16} />
          </button>
          <button className="branch-node-button">
            <Square size={16} />
          </button>
          <button className="branch-node-button">
            <Play size={16} />
          </button>
          <button className="branch-node-button">
            <MoreHorizontal size={16} />
          </button>
        </div>
      </div>

      {expanded && (
        <div className="branch-node-content">
          <div className="conditions-container">
            {conditions.map((condition, index) => (
              <div key={index} className="condition-item">
                <div className="condition-type">{getConditionType(index)}</div>
                <div className="condition-input-container">
                  <input
                    type="text"
                    value={condition.expression}
                    onChange={(e) => updateCondition(index, e.target.value)}
                    className="condition-input"
                    placeholder="Enter condition..."
                  />
                </div>
              </div>
            ))}
            <button className="add-condition-button" onClick={addCondition}>
              + Add Condition
            </button>
          </div>

          <div className="branch-tabs">
            <button
              className={`branch-tab ${activeTab === "Inputs" ? "active" : ""}`}
              onClick={() => setActiveTab("Inputs")}
            >
              Inputs
            </button>
            <button
              className={`branch-tab ${activeTab === "Settings" ? "active" : ""}`}
              onClick={() => setActiveTab("Settings")}
            >
              Settings
            </button>
            <button className="refresh-button">
              <span>⟳</span>
            </button>
          </div>
        </div>
      )}

      {/* Input handle at the top-left */}
      <div className="input-handle-container">
        <Handle
          type="target"
          position={Position.Left}
          id="b"
          className="connection-handle input-handle"
          style={{
            left: "-15px",
            top: "0",
            transform: "translateY(50%)",
          }}
        />
      </div>

      {/* Output handle at the top-right */}
      <div className="output-handle-container">
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          className="connection-handle output-handle"
          style={{
            right: "-15px",
            top: "0",
            transform: "translateY(50%)",
          }}
        />
      </div>

      {/* Add condition-specific output handles */}
      {expanded &&
        conditions.map((condition, index) => (
          <Handle
            key={`condition-${index}`}
            type="source"
            position={Position.Right}
            id={`condition-${index}`}
            className="condition-handle"
            style={{
              right: "-8px",
              top: `${120 + index * 50}px`, // Position based on condition index
              visibility: "hidden", // Hide these handles as we're using the main output handle
            }}
          />
        ))}
    </div>
  )
}

export default BranchNode
